
export function parseNumber(numberString: any, defaultValue?: number | null): number | undefined | null {
    const number = parseInt(numberString)
    if (typeof number === "number" && !isNaN(number))
        return number
    else 
        return defaultValue
}